export const isSuccessResponse = (statusCode?: number): boolean =>
  typeof statusCode === "number" && statusCode >= 200 && statusCode < 300;
